import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.find.js";
import "core-js/modules/es.iterator.map.js";
import "core-js/modules/es.iterator.some.js";
import RowActionsDropdown from "@components/DataTable.RowActions.Dropdown.vue";
import RowActionsInline from "@components/DataTable.RowActions.Inline.vue";
import CheckField from "@components/Fields/CheckField.vue";
import { SeekElementInBranch } from "@utils/DOMUtilities";
export default {
  components: {
    CheckField,
    RowActionsInline,
    RowActionsDropdown
  },
  props: {
    config: {
      type: Object,
      default() {
        return {};
      }
    },
    data: {
      type: Array,
      default() {
        return [];
      }
    },
    filters: {
      type: Object,
      default() {
        return {};
      }
    },
    filterExact: {
      type: Boolean,
      default() {
        return false;
      }
    },
    query: {
      type: String,
      default: ""
    },
    queryMode: {
      type: String,
      default: "contains"
    },
    locked: {
      type: Boolean,
      default: false
    },
    hiddenColumns: {
      type: Object,
      default() {
        return {};
      }
    },
    headless: {
      type: Boolean,
      default: false
    },
    rowActionClasses: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      default: {
        column: {
          renderer: function (data) {
            if (data) return data;else return "--";
          },
          classes: "",
          sortable: true,
          searchable: true
        }
      },
      empty: {
        text: "-- No Results Found --",
        classes: "py-5 alert-light text-center"
      },
      pageSizes: [10, 25, 50, 100],
      pageSize: 10,
      page: 0,
      sorting: [],
      rowSelect: false,
      tableClasses: "",
      rowClasses() {
        return null;
      },
      rowStyle() {
        return null;
      },
      hoveredRow: -1,
      hoverTimer: undefined,
      showActionPanel: false,
      actionsPanelOpen: false,
      rowKey: null,
      rowStates: [],
      onRowSelect: null,
      multiselect: false,
      selectAll: false,
      mouseX: -1,
      mouseY: -1
    };
  },
  mounted() {
    if (this.config.sorting) this.sorting = this.config.sorting;
    if (this.config.pageSize) this.pageSize = this.config.pageSize;
    if (this.config.pageSizes) {
      this.pageSizes = this.config.pageSizes;
      if (this.config.pageSizes.length > 0) this.pageSize = this.config.pageSizes[0];
    }
    if (this.config.rowSelect) this.rowSelect = this.config.rowSelect;
    if (this.config.onRowSelect) this.onRowSelect = this.config.onRowSelect;
    if (this.config.tableClasses) this.tableClasses = this.config.tableClasses;
    if (this.config.rowClasses) this.rowClasses = this.config.rowClasses;
    if (this.config.rowStyle) this.rowStyle = this.config.rowStyle;
    if (this.config.pageSize) this.pageSize = this.config.pageSize;

    // ROW-KEY DEPENDANT CONFIGS
    if (this.config.rowKey) {
      this.rowKey = this.config.rowKey;
      if (this.config.multiselect) this.multiselect = this.config.multiselect;
      if (this.config.selectAll === true || this.config.selectAll === false) this.selectAll = this.config.selectAll;else if (this.config.multiselect) this.selectAll = true;
    }
    document.addEventListener("mousemove", e => {
      this.mouseX = e.clientX;
      this.mouseY = e.clientY;
    });
  },
  computed: {
    columns() {
      return this.config.columns && this.config.columns.length ? this.config.columns.map(x => {
        let column = {};
        for (let key in this.default.column) {
          column[key] = this.default.column[key];
        }
        for (let key in x) {
          column[key] = x[key];
        }
        column.sorted = this.sorted(column.key);
        column.hidden = this.hidden(column.key);
        return column;
      }) : [];
    },
    rows() {
      return this.data.map(x => {
        if (!this.rowKey) return x;
        x.rowState = this.rowStates.find(y => y.key === x[this.rowKey]);
        return x;
      }).filter(x => {
        let context = this;
        let matches = 0;
        let checks = 0;
        for (let i = 0; i < this.columns.length; i++) {
          if (this.columns[i].searchable) {
            let val = this.columns[i].renderer(x[this.columns[i].key], x, "search");
            if (this.query && this.query != "") {
              checks++;
              this.page = 0;
              if (search(val, this.query, this.queryMode)) matches++;
            } else if (this.columns[i].query && this.columns[i].query != "") {
              checks++;
              let queryMode = this.columns[i].queryMode ? this.columns[i].queryMode : this.queryMode;
              if (search(val, this.columns[i].query, queryMode)) matches++;
            }
          }
        }
        let fChecks = 0;
        let fMatches = 0;
        for (let key in this.filters) {
          if (![undefined, null].some(x => x === this.filters[key]) && (!this.filters[key].replace || this.filters[key].replace && this.filters[key].replace(" ", "").length > 0)) {
            fChecks++;
            let test = x[key];
            let column = this.columns.find(y => y.key === key);
            if (column) test = column.renderer(x[key], x, "filter");
            if (filterTest(test, this.filters[key]) || Array.isArray(test) && test.some(y => filterTest(y, this.filters[key]))) fMatches++;
          }
        }
        let passedQuery = checks > 0 ? matches > 0 : true;
        let passedFilter = fChecks === fMatches;
        return passedQuery && passedFilter;
        function search(val, term, queryMode) {
          switch (queryMode.toLowerCase()) {
            case "contains":
              return (val + "").toLowerCase().indexOf(term.toLowerCase()) > -1;
            case "startswith":
              return (val + "").toLowerCase().indexOf(term.toLowerCase()) == 0;
            case "exact":
              return (val + "").toLowerCase() == term.toLowerCase();
          }
          return true;
        }
        function filterTest(test, filter) {
          return test == filter || !context.filterExact && test != null && test.indexOf && test.indexOf(filter) > -1;
        }
      }).sort((a, b) => {
        for (let i = 0; i < this.sorting.length; i++) {
          let key = this.sorting[i].key;
          let direction = this.sorting[i].direction;
          let column = this.columns.find(x => x.key == key);
          let value1 = column.renderer(a[key], a, "sort");
          if (value1.toLowerCase) value1 = value1.toLowerCase();
          let value2 = column.renderer(b[key], b, "sort");
          if (value2.toLowerCase) value2 = value2.toLowerCase();
          if (value1 < value2) return direction == "asc" ? -1 : 1;
          if (value1 > value2) return direction == "asc" ? 1 : -1;
        }
        return 0;
      });
    },
    rowActions() {
      if (!this.config.rowActions) return [];
      return this.config.rowActions.slice().map(x => {
        if (!x.evaluate) x.evaluate = function evaluate() {
          let abstract = JSON.parse(JSON.stringify(this));
          delete abstract.evaluate;
          return abstract;
        };
        return x;
      });
    },
    dataPage() {
      return this.rows.slice(this.pageSize * this.page, this.pageSize * (this.page + 1));
    },
    firstPage() {
      return this.page == 0;
    },
    lastPage() {
      return (this.page == 0 ? 1 : this.page + 1) * this.pageSize >= this.rows.length;
    },
    resultRange() {
      let from = 0;
      let to = 0;
      if (this.page == 0) from = 1;else from = this.page * this.pageSize + 1;
      to = this.page * this.pageSize + this.pageSize;
      if (to > this.rows.length) to = this.rows.length;
      return `${from}-${to}`;
    },
    hasActions: {
      cache: false,
      get() {
        return this.rowActions.length > 0;
      }
    },
    useActionMenu() {
      return this.rowActions.length > 3;
    },
    allRowsSelected() {
      return this.rows.length > 0 && this.rowStates.length == true && this.rows.filter(x => !x.rowState.selected).length === 0;
    },
    selectedRowCount() {
      return this.rows.filter(x => x.rowState && x.rowState.selected).length;
    }
  },
  watch: {
    data(val) {
      this.page = 0;
      if (this.rowKey) {
        this.rowStates = val.slice().map(x => {
          let existing = this.rowStates.find(y => y.key === x[this.rowKey]);
          if (existing) return existing;
          return {
            key: x[this.rowKey],
            selected: false
          };
        });
      }
    },
    pageSize() {
      if (this.rows.length <= this.pageSize) {
        this.page = 0;
      } else if (this.rows.length > 0) {
        while ((this.page == 0 ? 1 : this.page) * this.pageSize >= this.rows.length) {
          this.page--;
        }
      }
    },
    hoveredRow(val, prev) {
      this.hideActionPanelTooltips(prev);
      this.closeActionMenu(prev);
    },
    showActionPanel(val) {
      if (!val) {
        this.hideActionPanelTooltips(this.hoveredRow);
        this.closeActionMenu(this.hoveredRow);
      }
    }
  },
  methods: {
    sortBy(key, direction) {
      let i = this.sorting.findIndex(x => x.key == key);
      if (i > -1) {
        if (direction) this.sorting[i].direction = direction;else if (this.sorting[i].direction == "asc") this.sorting[i].direction = "desc";else this.sorting.splice(i, 1);
      } else this.sorting.push({
        key,
        direction: "asc"
      });
    },
    sorted(key) {
      let i = this.sorting.findIndex(x => x.key == key);
      return i > -1 ? this.sorting[i].direction : null;
    },
    sortPosition(key) {
      return this.sorting.findIndex(x => x.key === key) + 1;
    },
    hidden(key) {
      return this.hiddenColumns[key] === true;
    },
    next() {
      if (!this.lastPage) this.page++;
    },
    prev() {
      if (!this.firstPage) this.page--;
    },
    onRowAction({
      index,
      row,
      name
    }) {
      this.$emit(name, {
        index,
        row
      });
    },
    onActionPanelShow() {
      this.actionsPanelOpen = true;
    },
    onActionPanelHide() {
      // Clear lock
      this.actionsPanelOpen = false;

      // Identify current hover position
      const row = SeekElementInBranch(document.elementFromPoint(this.mouseX, this.mouseY), "hasAttribute", "data-row-index");
      if (row) {
        this.rowMouseEnter(row, +row.dataset.rowIndex);
      } else {
        this.rowMouseLeave(null, this.hoveredRow);
      }
    },
    toggleSelectedState(row) {
      let i = this.rowStates.findIndex(x => x.key === row[this.rowKey]);
      if (i > -1) {
        this.rowStates[i].selected = !this.rowStates[i].selected;
        this.$emit("row-state-change", this.rowStates);
      }
    },
    toggleSelectAll() {
      let bit = this.allRowsSelected;
      for (let i = 0; i < this.rows.length; i++) {
        let row = this.rows[i];
        let stateIndex = this.rowStates.findIndex(x => x.key === row[this.rowKey]);
        if (stateIndex > -1) this.rowStates[stateIndex].selected = !bit;
      }
      this.$emit("row-state-change", this.rowStates);
    },
    rowSelected(row, index, event) {
      if (this.onRowSelect) {
        this.onRowSelect(row, index, event);
      }
      let data = JSON.parse(JSON.stringify(row));
      delete data.rowState;
      this.$emit("row-selected", data, index);
    },
    rowMouseEnter(row, rIndex) {
      if (!this.hasActions || this.actionsPanelOpen) return;
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
      }
      this.hoverTimer = setTimeout(() => {
        this.hoveredRow = rIndex;
        let actionPanel = this.$refs[`actionPanel_${rIndex}`][0];
        let dtw = this.$refs.wrapper;
        let scrollContainer = this.$refs.scrollContainer;
        if (row && dtw && row.scrollWidth > dtw.scrollWidth) {
          let rowRect = row.getBoundingClientRect();
          let dtwRect = dtw.getBoundingClientRect();
          if (scrollContainer && actionPanel && scrollContainer.scrollWidth - dtw.offsetWidth > scrollContainer.scrollLeft + actionPanel.offsetWidth + 16) {
            let top = rowRect.y - dtwRect.y + row.offsetHeight / 2 - actionPanel.offsetHeight / 2;
            let left = dtwRect.width - 16 - actionPanel.offsetWidth;
            actionPanel.style.top = `${top}px`;
            actionPanel.style.left = `${left}px`;
            this.showActionPanel = true;
          } else this.showActionPanel = false;
        } else this.showActionPanel = false;
      }, 0);
    },
    rowMouseLeave(row, rIndex) {
      if (!this.hasActions || this.actionsPanelOpen) return;
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer);
      }
      this.hoverTimer = setTimeout(() => {
        this.hoveredRow = -1;
        this.showActionPanel = false;
        this.hideActionPanelTooltips(rIndex);
        this.closeActionMenu(rIndex);
      }, 0);
    },
    hideActionPanelTooltips(index) {
      let targets = this.$refs[`actionPanel_${index}`];
      if (targets) {
        let actionPanel = targets[0];
        if (actionPanel) $(actionPanel.querySelectorAll('*[data-toggle="tooltip"]')).tooltip("hide");
      }
    },
    closeActionMenu(index) {
      if (index < 0) return;
      let actionPanel = this.$refs[`actionPanel_${index}`][0];
      if (this.useActionMenu && actionPanel) {
        let button = actionPanel.querySelector("div.dropleft button");
        if (button.getAttribute("aria-expanded") == "true") {
          $(button).dropdown("toggle");
        }
      }
    },
    setRowStates(states) {
      if (this.rowKey) {
        if (this.rows.length > 0) {
          this.rowStates = this.data.slice().map(x => {
            let state = states.find(y => y.key === x[this.rowKey]);
            if (state) return state;
            return {
              key: x[this.rowKey],
              selected: false
            };
          });
        } else this.rowStates = states;
      }
      this.$emit("row-state-change", this.rowStates);
    }
  }
};